"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Feedback_1 = require("./Feedback");
exports.default = Feedback_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/panels/Feedback/index.js
// module id = 1394
// module chunks = 8